import { useState } from "react";
import { navigate } from "../lib/useHashRoute";
import { IconSearch, IconWeb, IconUser } from "./Icons";

/**
 * Endereço que não existe. Antes o site devolvia a busca com status 200 para
 * qualquer caminho desconhecido: quem errava a URL achava que tinha sido
 * ignorado, e o buscador registrava um "soft 404" — página de erro que se
 * apresenta como página boa.
 *
 * O caso mais comum aqui não é link quebrado, é CNPJ digitado a menos: por isso
 * a busca fica no meio da página, já pronta.
 */
export function NotFoundPage({ path }: { path: string }) {
  const [termo, setTermo] = useState("");
  const digitos = path.replace(/\D/g, "");
  const pareceCnpjIncompleto = digitos.length > 0 && digitos.length < 14 && /^\/(empresa|rede)\//.test(path);

  return (
    <main className="page container not-found-page">
      <header className="not-found-head">
        <span className="badge plain">Erro 404</span>
        <h1 className="page-title">Este endereço não existe</h1>
        <p className="page-subtitle">
          Não há nada em <code className="mono">{path}</code>.{" "}
          {pareceCnpjIncompleto
            ? `O trecho numérico tem ${digitos.length} dígito${digitos.length > 1 ? "s" : ""}, e um CNPJ tem 14 — o endereço provavelmente ficou incompleto.`
            : "O link pode estar quebrado, ou o endereço mudou."}
        </p>
      </header>

      <form
        className="not-found-search"
        role="search"
        onSubmit={(event) => {
          event.preventDefault();
          const busca = termo.trim();
          if (!busca) return;
          navigate({ page: "home", mode: "auto", q: busca });
        }}
      >
        <IconSearch size={16} />
        <input
          value={termo}
          onChange={(event) => setTermo(event.target.value)}
          placeholder="CNPJ, razão social ou nome de sócio"
          aria-label="Buscar empresa, sócio ou CNPJ"
          autoFocus
        />
        <button className="btn btn-primary" type="submit">Buscar</button>
      </form>

      <nav className="not-found-links" aria-label="Páginas do site">
        <button className="not-found-link" onClick={() => navigate({ page: "home" })}>
          <IconSearch size={15} />
          <span>
            <strong>Buscar no Teia</strong>
            <small>CNPJ, razão social, nome fantasia ou sócio</small>
          </span>
        </button>
        <button className="not-found-link" onClick={() => navigate({ page: "guide" })}>
          <IconUser size={15} />
          <span>
            <strong>Como consultar</strong>
            <small>O que os dados abertos trazem e o que não trazem</small>
          </span>
        </button>
        <button className="not-found-link" onClick={() => navigate({ page: "connect" })}>
          <IconWeb size={15} />
          <span>
            <strong>Conectar a IA</strong>
            <small>Servidor MCP aberto, sem cadastro</small>
          </span>
        </button>
      </nav>
    </main>
  );
}
